var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "number-value" }, [
    _vm.label
      ? _c("div", { staticClass: "number-value__label c-input-label" }, [
          _vm._v(" " + _vm._s(_vm.label) + " "),
          _vm.fullLabel
            ? _c(
                "div",
                { staticClass: "c-input-label-fullname" },
                [
                  _c("c-button", {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.html",
                        value: {
                          container: "#app",
                          trigger: "hover",
                          content: _vm.fullLabel,
                          placement: "bottom",
                        },
                        expression:
                          "{\n          container: '#app',\n          trigger: 'hover',\n          content: fullLabel,\n          placement: 'bottom',\n        }",
                        modifiers: { html: true },
                      },
                    ],
                    attrs: { size: "iconic", icon: "info" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _c("div", { staticClass: "number-value__container" }, [
      _c(
        "div",
        { staticClass: "number-value__type" },
        [
          _c("c-switcher", {
            staticClass: "h-switcher",
            attrs: {
              value: _vm.type,
              type: "group",
              label: _vm.label,
              "label-full-name": _vm.fullLabel,
              items: _vm.items,
            },
            on: { input: _vm.updateType },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "number-value-fields" },
        [
          _c("div", { staticClass: "number-value-fields__wrapper" }, [
            _vm.isRange
              ? _c(
                  "div",
                  { staticClass: "number-value__range" },
                  [
                    _c("c-input", {
                      staticClass: "range-input-width",
                      attrs: {
                        type: "price-number",
                        placeholder: "0",
                        split: true,
                        "required-message": _vm.error,
                        "max-length": 11,
                      },
                      model: {
                        value: _vm.from,
                        callback: function ($$v) {
                          _vm.from = $$v
                        },
                        expression: "from",
                      },
                    }),
                    _c("span", { staticClass: "range-dash" }, [_vm._v("–")]),
                    _c("c-input", {
                      staticClass: "range-input-width",
                      attrs: {
                        type: "price-number",
                        placeholder: "0",
                        split: true,
                        "required-message": _vm.error,
                        "max-length": 11,
                      },
                      model: {
                        value: _vm.to,
                        callback: function ($$v) {
                          _vm.to = $$v
                        },
                        expression: "to",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "number-value__value" },
                  [
                    _c("c-input", {
                      staticClass: "range-input-width",
                      attrs: {
                        type: "price-number",
                        placeholder: "0",
                        split: true,
                        "required-message": _vm.error,
                        "max-length": 11,
                      },
                      model: {
                        value: _vm.number,
                        callback: function ($$v) {
                          _vm.number = $$v
                        },
                        expression: "number",
                      },
                    }),
                  ],
                  1
                ),
            _c("span", { staticClass: "number-value__unit" }, [
              _vm._v(_vm._s(_vm.unit)),
            ]),
          ]),
          _vm.error
            ? _c("error-feedback", {
                staticClass: "number-value__error",
                attrs: { text: _vm.error },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }